// extracted by mini-css-extract-plugin
export default {"fileDownloadLabels":"ImageCardDownload_fileDownloadLabels__ms+Vy","menuItem":"ImageCardDownload_menuItem__emtB9"};